/**
 *
 * FormInput
 *
 */

import React, { memo } from 'react';
import PropTypes from 'prop-types';
import { Form } from '@cashfree-intl/coherent';
import ErrorMessage from '../ErrorMessage';

import { filterAllowedValues } from '../../utils/common';
// import './style.scss';
// import styled from 'styled-components';

function FormInput(props) {
  const { errors, touched, clss = '', allowedValues = '', ...rest } = props;

  const options = {};
  if (allowedValues) {
    options.onInput = e => {
      let res = '';
      String(e.target.value)
        .split('')
        .forEach(elem => {
          const asciiValue = elem.charCodeAt(0);
          if (
            filterAllowedValues({
              allowedValuesType: allowedValues,
              asciiValue,
            })
          ) {
            res += elem;
          }
        });
      e.target.value = res;
    };
  }

  return (
    <div
      className={`form-input-wrapper ${clss} ${
        errors[rest.name] && touched[rest.name] ? 'error_border' : ''
      }`}
    >
      <Form.Input {...rest} {...options} />
      <ErrorMessage name={rest.name} />
    </div>
  );
}

FormInput.propTypes = {
  name: PropTypes.string,
  clss: PropTypes.string,
  errors: PropTypes.object,
  touched: PropTypes.object,
  allowedValues: PropTypes.string,
};

export default memo(FormInput);
